<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col :span="4" class="cs-main-left-container">
        <comNavigator></comNavigator>
      </el-col>
      <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
        <div class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white cs-contentContainer-right-content cs-fullHeight">
            <el-row>
              <span class="cs-title">讲解视频</span>
              <el-row class="grid-content" v-loading="isInit">
                <el-row>
                  <el-col :span="5" v-if="hasTeacher">
                    <el-select placeholder="老师" filterable v-model="teacherUserId" size="medium" @change="onTeacherChange">
                      <el-option label="所有老师" :value="0" />
                      <el-option v-for="item in teacherList" :key="item.UserId" :label="item.Name" :value="item.UserId">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="5" v-if="hasCourseType">
                    <el-select placeholder="课程类型" v-model="courseType" size="medium" @change="onCourseTypeChange" :class="{'margin-left-20px': hasTeacher}">
                      <el-option v-for="item in courseTypeList" :key="item.key" :label="item.value" :value="item.key">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="5">
                    <el-select v-show="displayCourseList" placeholder="课程" v-model="selectedCourseKey" size="medium" @change="onCourseChange"
                      :class="{'margin-left-20px': hasCourseType || hasTeacher}">
                      <el-option v-for="item in courseList" :key="item.key" :label="item.name" :value="item.key">
                      </el-option>
                    </el-select>
                    <span v-show="!displayCourseList">&nbsp;</span>
                  </el-col>
                  <el-col :span="5" v-if="!hasCourseType">
                    <span>&nbsp;</span>
                  </el-col>
                  <el-col :span="5" v-if="!hasTeacher">
                    <span>&nbsp;</span>
                  </el-col>
                  <el-col :span="9" class="text-right">
                    <el-button size="medium" v-if="hasCourse && isTeacher" type="primary" :disabled="isInit || loading" @click="onAdd">添加</el-button>
                  </el-col>
                </el-row>
                <pagination v-loading="loading || isInit" :data="listData" :option="paginationOption" @search="search" @loadData="onLoadList"
                  @pageSizeChange="pageSizeChange" @currentPageChange="currentPageChange" @edit="onEdit" @additional="onAdditional"></pagination>
              </el-row>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <emailVideoEditor key="emailVideoEditor" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)" :courseType="courseType" :courseKey="selectedCourseKey"
      :emailVideoId="currentId" :type="editorType" @change="onEditorChange" />

    <el-dialog class="cs-aliyunVideo-container" v-if="aliyunVideoViewVisible" :center="true" :close-on-click-modal="false"
      :visible.sync="aliyunVideoViewVisible" @close="onCloseAliyunVideo" top="8vh" width="900px">
      <aliyunVideoPlayer
        v-if="aliyunVideoInfo"
        :videoInfo="aliyunVideoInfo"
        :hideErrorMessage="hideAliyunVideoPlayerError"
        @play="onAliyunVideoPlayerPlay"
        @pause="onAliyunVideoPlayerPause"
      />
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped></style>

<script>
import comNavigator from "../../components/navigator";
import pagination from "../../components/common/pagination";
import { getTeacherAllCourseList } from "../../service/teacherCourse.service";
import {
  getEmailVideoList,
  getEmailVideoTeachers,
} from "../../service/emailVideo.service";
import { getAliyunVodVideoInfo } from "@/service/alibabaCloud.service";

export default {
  data() {
    return {
      isInit: true,
      loading: false,
      hasCourse: true,
      hasCourseType: false,
      displayCourseList: false,
      pageSize: 20,
      paginationOption: {},
      teacherUserId: 0,
      courseType: "",
      selectedCourseKey: "",
      listData: [],
      courseTypeList: [],
      courseList: [],
      teacherUniversityCourseList: [],
      teacherTrainingCourseList: [],
      dialogEditorVisible: false,
      currentId: null,
      editorType: 0,
      isTeacher: false,
      hasTeacher: false,
      teacherList: [],
      aliyunVideoViewVisible: false,
      aliyunVideoInfo: null,
      isAliyunVideoPlayerPlay: false,
      hideAliyunVideoPlayerError: true
    };
  },
  components: {
    comNavigator,
    pagination,
    emailVideoEditor: () => import("@/components/emailVideo/emailVideoEditor"),
    aliyunVideoPlayer: () => import("@/components/aliyunVod/aliyunVideoPlayer"),
  },
  computed: {},
  created() {
    this.isTeacher = this.USERMANAGER.isTeacher;
    this.courseTypeList = [
      { key: 0, value: "所有" },
      { key: 1, value: "大学补习" },
      { key: 3, value: "职业培训" },
    ];
    this.courseType = 0;
    let additionalColumns = [
      // {
      //   name: "Resending",
      //   title: "",
      //   buttonText: "重发",
      // },
    ];
    if (this.hasCourse && this.isTeacher) {
      additionalColumns.push({
        name: "Edit",
        title: "",
        buttonText: "编辑",
      });
    }
    this.paginationOption = {
      displayPagination: true,
      hasEditButton: true,
      editButtonText: "查看视频",
      fnRowEditVisible: this.onRowEditVisible,
      hasAddButton: false,
      hasSearch: false,
      hasDeleteButton: false,
      isNotTeacher: !this.USERMANAGER.isTeacher,
      isNotStudent: true,
      additionalColumns,
    };
    if (this.isTeacher) {
      this.loadTeacherCourseList(null);
      this.hasTeacher = false;
    } else {
      this.hasTeacher = true;
      this.hasCourseType = false;
      this.loadTeacherList();
      this.search();
    }
  },
  methods: {
    async getAliyunVodVideoInfoFromServer(videoFileId) {
      try {
        let result = await getAliyunVodVideoInfo(videoFileId);
        if (!!result && result.success) {
          this.aliyunVideoInfo = result.data;
        }
      } catch (error) {
        console.error(error);
      }
    },

    loadTeacherList() {
      getEmailVideoTeachers().then((result) => {
        if (!!result && result.success) {
          this.teacherList = result.data;
        }
        this.isInit = false;
      });
    },
    loadTeacherCourseList(teacherId) {
      getTeacherAllCourseList(teacherId, false).then((result) => {
        if (!!result && result.success) {
          this.teacherUniversityCourseList = result.data.TeacherCourseList;
          this.teacherTrainingCourseList =
            result.data.TeacherTrainingCourseList;
          if (
            this.teacherUniversityCourseList.length > 0 &&
            this.teacherTrainingCourseList.length > 0
          ) {
            this.courseType = 0;
            this.hasCourseType = true;
          } else {
            if (this.teacherUniversityCourseList.length > 0) {
              this.courseType = 1;
            } else if (this.teacherTrainingCourseList.length > 0) {
              this.courseType = 3;
            } else {
              this.courseType = 0;
            }
            if (
              this.teacherUniversityCourseList.length == 0 &&
              this.teacherTrainingCourseList.length == 0
            ) {
              this.hasCourse = false;
              return;
            }
            this.loadCourseList();
          }
          this.search();
        }
        this.isInit = false;
      });
    },
    onTeacherChange() {
      let teacherId = null;
      if (!!this.teacherUserId) {
        let teacher = this.teacherList.find(
          (i) => i.UserId == this.teacherUserId
        );
        if (teacher) {
          teacherId = teacher.Id;
        }
      }
      if (!teacherId) {
        this.hasCourseType = false;
        this.courseType = 0;
        this.displayCourseList = false;
        this.selectedCourseKey = "";
        this.search();
      } else {
        this.loadTeacherCourseList(teacherId);
      }
    },
    onCourseTypeChange() {
      this.loadCourseList();
      this.search();
    },
    onCourseChange() {
      this.search();
    },
    loadCourseList() {
      let list = [];
      if (this.courseType === 1) {
        list = this.teacherUniversityCourseList.map((i) => {
          return {
            key: `${i.CourseId}`,
            name: i.CourseName,
            courseId: i.CourseId,
            campusId: null,
          };
        });
      } else if (this.courseType === 3) {
        list = this.teacherTrainingCourseList.map((i) => {
          return {
            key: `${i.CourseId}-${i.CampausId}`,
            name: `${i.CourseName}(${i.CampausName})`,
            courseId: i.CourseId,
            campusId: i.CampausId,
          };
        });
      }
      list.splice(0, 0, {
        key: "",
        name: "所有",
        courseId: null,
        campusId: null,
      });
      this.courseList = list;
      this.selectedCourseKey = "";
      if (this.courseType) {
        this.displayCourseList = true;
      } else {
        this.displayCourseList = false;
      }
    },
    onEdit(index, row) {
      this.$nextTick(async () => {
        if (row.VideoPlatform === this.GLOBAL.enumVideoPlatform.AliyunVod) {
          await this.getAliyunVodVideoInfoFromServer(row.VideoFileId);
          this.aliyunVideoViewVisible = true;
        } else {
          if (!row.SproutVideoUrl) {
            this.$message.warning("请等待完成转码");
            return;
          }
          window.open(row.SproutVideoUrl, "_blank");
        }
      });
    },
    onSearch() {
      this.search();
    },
    search(pageNumber) {
      let pageData = this.getSearchPageData(pageNumber);
      this.loadListData(pageData);
    },
    onLoadList(pageData) {
      this.search(pageData.pageNumber);
    },
    loadListData(pageData) {
      this.loading = true;
      getEmailVideoList(pageData)
        .then((result) => {
          if (!!result && result.success) {
            this.listData = result.data;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    pageSizeChange(value) {
      this.pageSize = value;
    },
    currentPageChange(value) {
      this.listData.CurrentPage = value;
    },
    getSearchPageData(pageNumber) {
      if (typeof pageNumber == "undefined") {
        pageNumber = 1;
      }

      let courseId = 0;
      let campusId = 0;
      if (this.courseType && this.selectedCourseKey) {
        if (this.courseType === 1) {
          courseId = this.selectedCourseKey;
        } else if (this.courseType === 3) {
          let item = this.courseList.find(
            (i) => i.key === this.selectedCourseKey
          );
          courseId = item.courseId;
          campusId = item.campusId;
        }
      }
      let additionalFilter = {
        teacherUserId: this.teacherUserId,
        courseType: this.courseType,
        courseId: courseId,
        campusId: campusId,
      };
      let pageData = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
        keyWord: "",
        additionalFilter: additionalFilter,
      };

      return pageData;
    },
    onAdditional(name, index, row) {
      switch (name) {
        case "Resending": {
          this.currentId = row.Id;
          this.editorType = 1;
          let refEditor = this.$vueRefStore.getChildrenRef("emailVideoEditor");
          if (!!refEditor) {
            refEditor.showDialog();
          }
          break;
        }
        case "Edit": {
          this.currentId = row.Id;
          this.editorType = 0;
          let refEditor = this.$vueRefStore.getChildrenRef("emailVideoEditor");
          if (!!refEditor) {
            refEditor.showDialog();
          }
          break;
        }
      }
    },
    onAdd() {
      this.currentId = null;
      let refEditor = this.$vueRefStore.getChildrenRef("emailVideoEditor");
      if (!!refEditor) {
        refEditor.showDialog();
      }
    },
    onEditorChange(model) {
      this.search();
    },
    onRowEditVisible(index, row) {
      if (row.VideoPlatform === this.GLOBAL.enumVideoPlatform.AliyunVod) {
        if (!!row.VideoFileId) return true;
      } else {
        if (!!row.SproutVideoUrl) return true;
      }

      return false;
    },

    onCloseAliyunVideo() {
      this.aliyunVideoViewVisible = false;
      this.isAliyunVideoPlayerPlay = false;
    },
    onAliyunVideoPlayerPlay() {
      this.isAliyunVideoPlayerPlay = true;
    },
    onAliyunVideoPlayerPause() {
      this.isAliyunVideoPlayerPlay = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.cs-aliyunVideo-container {
  ::v-deep .el-dialog__headerbtn {
    top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/teacher/emailVideoList.vue